export const InspectionsTranslationsDictionary = {
    // photo validation
    CheckThisPhoto: "Check this photo",
    Retake: "Retake",
    KeepPhoto: "Keep photo",
    PhotoLooksBlurry: "The photo looks blurry.",
    PhotoLooksDark: "The photo looks too dark.",
    PhotoLowResolution: "The photo resolution is low.",
    PhotoStale: "This photo appears to have been taken more than an hour before the inspection started.",
    PhotoDuplicate: "This photo looks like a duplicate of another photo in this inspection.",
    PhotoFarFromAsset: "The photo was taken {0} m away from the asset.",
    PhotoWarningsKeepOrRetake: "You can keep this photo or retake it. Kept photos are flagged for review.",

    // main page
    AssetInspection: "Asset Inspection",
    Assets: "Assets",
    Incomplete: "Incomplete",
    History: "History",
    SearchAssets: "Search asset",
    ScanQRCode: "Scan QR code",
    FilterAssets: "Filter assets",
    AssignedAssets: "Assigned assets",
    AssetsNearby: "Nearby assets",
    InspectionHistory: "Inspection History",
    NoResultsFound: "No results found",
    NoInspectionHistoryMessage: "You haven't inspected any assets yet. View assets assigned to you or use the search bar above to start an inspection.",
    NoRecentOrNearbyVehicles: "Could not find any recent or nearby vehicles.",
    AllFilters: "All Filters",
    AssetType: "Asset type",
    SelectAssetType: "Select asset type",
    ShowArchivedAssets: "Show archived assets",
    Apply: "Apply",
    Cancel: "Cancel",
    Clear: "Clear",
    LastInspected: "Last inspected",
    Selected: "Selected",
    None: "None",
    All: "All",

    // asset type names (returned by API in English; must be translated for display)
    Vehicle: "Vehicle",
    Trailer: "Trailer",
    Equipment: "Equipment",
    Container: "Container",
    Generator: "Generator",

    // asset card
    VIN: "VIN",
    AssetNumber: "Asset number",
    Inspector: "Inspector",
    SubmittedBy: "Submitted by",
    Status: "Status",
    Completed: "Completed",
    Away: "away",

    // createInspection page
    SelectChecklist: "Select checklist",
    NoTemplatesFound: "No templates found for this asset type",
    ViewOnMap: "View on map",
    MakeModelYear: "Make / Model / Year",
    LicensePlate: "License plate",
    Odometer: "Odometer",
    AdjustedOdometer: "Adjusted odometer",
    AdjustedOdometerInfo: "Matches the reading shown in MyGeotab. Trip history and Hours of Service logs use the raw reading, as GPS-derived data can't be used for Hours of Service.",
    Hubometer: "Hubometer",
    AdjustedHubometer: "Adjusted hubometer",
    EngineHours: "Engine hours",
    LoadHeight: "Load height",
    LoadWidth: "Load width",
    ViewOnlyMode: "You have view-only access to asset inspections.",
    SelectInspectionType: "Select inspection type",
    PreTrip: "Pre-trip",
    MidTrip: "Mid-trip",
    PostTrip: "Post-trip",
    Other: "Other",
    InspectionTypeContext: "Inspection context",
    InspectionTypeContextPlaceholder: "Describe the inspection (required)",
    InspectionTypeNoteRequired: "Enter a description for an Other inspection",
    Inspect: "Inspect",
    RecertifyDescription: "Pre-fill this inspection using answers from the previous one.",
    PreviousInspectionFound: "An inspection already exists for this asset.",
    ContinueFromPrevious: "Use Previous Answers",
    StartFromZero: "Start Fresh",
    // Labels local to the recertification step. Template/InspectionType/Inspector are shared with
    // the asset card and history details, which keep their own wording.
    RecertifyChecklistLabel: "Checklist",
    RecertifyTypeLabel: "Type",
    RecertifyInspectedByLabel: "Inspected By",
    RecertifyDateLabel: "Date",
    SaveForLater: "Save for later",
    AssetCondition: "Take walkaround photos",
    AssetConditionSubtitle: "Document the condition of the asset as labeled (eg. asset exterior, engine hours)",
    WalkaroundPhotos: "Walkaround photos",
    InspectionDetails: "Inspection details",
    NoDefects: "No defects",
    ToggleOnDefectPresent: "Toggle ON if a defect is present",
    RequiredItemCount: "{0} required item",
    RequiredItemCountPlural: "{0} required items",

    // inspectionItemCard
    AddOther: "Add other",
    EnterDefectDescription: "Enter defect description",
    Value: "Value",
    EnterValue: "Enter value",
    InvalidNumberValue: "Enter a valid number",
    Pass: "Pass",
    Fail: "Fail",
    MarkAllAsPass: "Mark all as Pass",
    UnmarkAllAsPass: "Unmark all as Pass",

    // inspectionItemCard / inspectionHistoryItemRow
    Images: "Defect images",
    Notes: "Notes",
    AddNotesAboutDefect: "Description",
    Severity: "Severity",
    NotApplicable: "N/A",
    Major: "Major",
    Minor: "Minor",
    Cosmetic: "Cosmetic",
    ReplacePhoto: "Replace photo",
    Close: "Close",

    // validation
    FieldRequired: "This field is required",

    // inspectionDetails page
    Submit: "Submit",
    ErrorNoTemplateOrAsset: "Select a template or asset before submitting",
    SelectNoDefectInstruction: "Select \"no defect\" if everything is normal (required for submission)",
    SubmitError: "Couldn't submit inspection. Try again",
    SaveForLaterError: "Couldn't save inspection. Try again",
    RemarkLengthError: "Remark must not exceed 500 characters",
    RequiredSectionMissing: "Fill in all required fields",

    // inspectionSubmitted page
    InspectionSubmittedTitle: "Inspection submitted",
    InspectionComplete: "Inspection complete",
    InspectionDoneWithDuration: "Inspection done in {0}.",
    InspectionDoneWithHos: "Inspection done in {0}. You're On Duty as of {1}.",
    OnDuty: "On Duty",
    UserIsNowStatus: "{0} is now {1}",
    StartNewInspection: "Start new inspection",
    Exit: "Exit",

    // inspectionHistoryDetails page
    DefectsFound: "Defects found",
    LogStatusSubmitted: "Submitted",
    LogStatusInReview: "In review",
    LogStatusReviewed: "Reviewed",
    LogStatusReviewFailed: "Review failed",
    LogStatusComplete: "Complete",

    // inspectionPhotoViewer / inspectionThumbnailImage
    FailedToLoadImage: "Failed to load image",
    ViewPhoto: "View photo",

    // RepairStatusType enum values
    Acknowledged: "Acknowledged",
    RepairStatus: "Repair status",
    Repaired: "Repaired",
    NotRepaired: "Not repaired",
    NotNecessary: "Not necessary",
    // A driver rejected a recorded repair on a later inspection. Byte-identical to the
    // MyGeotab admin UI's label so both surfaces share one translation entry.
    RepairDisputed: "Repair disputed",

    // InspectedItemStatus enum values (status pill labels; Pass/Fail/Repaired/NotRepaired reuse keys above)
    Reported: "Reported",
    InProgress: "In progress",
    Closed: "Closed",
    Monitoring: "Monitoring",
    RepairNotNecessary: "Repair not necessary",
    Invalid: "Invalid",
    Unknown: "Unknown",

    // inspectionHistoryDetails metadata
    InspectionId: "Inspection ID",
    InspectedBy: "Inspected by",
    Template: "Template",
    InspectionType: "Inspection type",

    // inspectionHistoryDetails roadside/regulatory presentation
    Regulatory: "Regulatory",
    NonRegulatory: "Non-regulatory",
    Classification: "Classification",
    Driver: "Driver",
    DriversLicense: "Driver's license",
    CarrierNumber: "Carrier number",
    CertifiedBy: "Certified by",
    CertifiedOn: "Certified on",
    RepairedBy: "Repaired by",
    RepairedOn: "Repaired on",
    Trailers: "Trailers",

    // inspection location
    InspectionLocation: "Location",
    DetectingLocation: "Detecting location...",
    LocationPlaceholder: "Enter an address",
    AddressNotFound: "Couldn't find that address",
    LocationDetectionFailed: "Your current location could not be detected. Please enter your address.",
    EnterAddressModalTitle: "Enter an address",
    AddressOrIntersection: "Address or intersection",
    City: "City",
    StateProvince: "State/province",
    Country: "Country",
    EditLocationAriaLabel: "Edit inspection location",
    OK: "OK",

    // incomplete tab
    Progress: "Progress",
    ItemsCompleted: "Items completed: {0} of {1}",
    Saved: "Saved {0}",
    ItemsReviewed: "Reviewed: {0}/{1}",

    // delete inspection modal
    DeleteInspectionConfirmBody: "Deleting this inspection permanently removes its record and associated data. This deletion cannot be undone.",
    Delete: "Delete",
    DeleteInspectionError: "Couldn't delete inspection. Try again.",

    // history filter sheet
    InspectionFilters: "Inspections",
    DateStart: "Start date",
    DateEnd: "End date",
    SelectStatus: "Select status",
    SelectTemplate: "Select template",
    DefectPresence: "Defect presence",
    WithDefects: "With defects",
    WithoutDefects: "Without defects",
    LogStatusDraft: "Draft",

    // navigation guard dialog
    NavigationGuardTitle: "Unsaved progress",
    NavigationGuardBody1: "You have unsaved progress. If you leave this screen, you'll lose all the progress you've made.",
    NavigationGuardBody2: "Leave without saving?",
    Stay: "Stay",
    Leave: "Leave",

    // camera permission dialogs
    CameraPermissionTitle: "Camera access required",
    CameraPermissionBody: "To take a photo of an asset, Geotab Drive needs access to your camera.",
    Allow: "Allow",
    DontAllow: "Don't allow",
    CameraAccessDeniedTitle: "Camera access denied",
    CameraAccessDeniedBody: "Drive needs camera permission to take photos of assets",
    CameraAccessDeniedStep1: "Open your device settings",
    CameraAccessDeniedStep2: "Find and tap \"Drive\" app",
    CameraAccessDeniedStep3: "Enable camera permission",
    OpenSettings: "Open settings",
    EnterManually: "Enter manually",

    // reviewUnrepairedDefectsSheet
    RepairNote: "Repair note",
    AddRepairNote: "Add a repair note (optional)",
    UnrepairedDefects: "Unrepaired defects",
    ReviewUnrepairedDefects: "Review unrepaired defects",
    ProceedWithDefects: "Proceed with defects ({0})",
    ProceedWithInspection: "Proceed with inspection",
    RepairError: "Failed to mark defects as repaired. Please try again.",
    RepairPermissionRequired: "You don't have permission to mark defects as repaired. Contact your administrator.",
    LinkDefectsError: "Could not link carry-forward defects. They are still linked to previous inspection(s). Your inspection was saved.",
    LinkDefectsPartialError: "Some carry-forward defect(s) could not be added to this inspection. They are still linked to previous inspection(s). Your inspection was saved successfully.",
    LoadDefectsError: "Failed to load unrepaired defects. Please try again.",

    // reviewRepairedDefectsSheet
    ReviewRepairedDefects: "Previous defect review",
    ReviewRepairedDefectsSubtitle: "These defects were marked as repaired. Verify the repair or reflag if the issue persists.",
    VerifyRepair: "Verified",
    StillDefective: "Still defective",
    ReportedOn: "Reported",
    RepairedDefectsError: "Couldn't update defect status. Try again.",
    // Admin status-change justification shown on the repaired defect card.
    // Values match the MyGeotab admin UI's REASON_CODES labels (inspectedItemsList.tsx) so the
    // phrases resolve against the existing en.json entries.
    Reason: "Reason",
    Comment: "Comment",
    ReasonRepairedByMechanic: "Repaired by mechanic",
    // Written with repairSource="Driver" by a driver's own repair (markDefectAsRepaired), which the
    // repaired review excludes, and never offered in the admin's dropdown. Labelled here so an
    // Admin-source item that still carries it (e.g. written through the API) reads as a phrase
    // rather than a raw enum name.
    ReasonRepairedByDriver: "Repaired by driver",
    ReasonMonitoringScheduled: "Monitoring scheduled",
    ReasonInvalidDataEntryError: "Invalid: data entry error",
    // Reason codes written by this sheet's own verdicts. They surface here only in
    // the edge case where an admin re-transitions a driver-reviewed item back to Repaired without
    // supplying a fresh reason; byte-identical to the admin UI's labels, so they share one
    // translation entry rather than needing their own.
    ReasonDefectStillPresent: "Defect still present",
    ReasonRepairVerified: "Repair verified",

    // reviewAndCertify page
    ReviewAndSign: "Review & Sign",
    Back: "Back",
    Signature: "Signature",
    AddSignature: "Add signature",

    // certification declaration text
    CertificationDeclarationAlberta: "I declare that the {0} shown above has been inspected in accordance with the requirements set forth in the Alberta Regulation 121/2009",
    CertificationDeclarationBcNovaScotia: "I declare that the {0} shown above has been inspected in accordance with the requirements set forth in the Canadian Federal NSC Standard 13",
    CertificationDeclarationGeneralCanada: "I declare that the {0} shown above has been inspected in accordance with applicable requirements",
    CertificationDeclarationManitoba: "I declare that the {0} shown above has been inspected in accordance with regulation M.R. 95/2008",
    CertificationDeclarationOntario: "This {0} was inspected in accordance with Regulation. O. Reg. 199/07",
    CertificationDeclarationGeneric: "I certify this inspection",

    // certification
    CertificationSectionHeading: "Certification",
    CertifyRemarkLabel: "Remark",
    CertifyRemarkPlaceholder: "Add a remark (optional)",

    // authority / carrier fields
    AuthorityNameLabel: "Authority name",
    AuthorityAddressLabel: "Authority address",
    AuthorityNamePlaceholder: "Enter authority name (optional)",
    AuthorityAddressPlaceholder: "Enter authority address (optional)",

    // safe to operate
    SafeToOperateSectionHeading: "Safe to operate",
    SafeToOperateLabel: "This vehicle is safe to operate",
    UnsafeWarningVehicle: "This report identifies major defects with this vehicle.",
    UnsafeWarningTrailer: "This report identifies major defects with this trailer.",
    ConfirmSafeOverride: "Confirm safe to operate",
    ConfirmSafeOverrideBody: "You are marking this asset as safe to operate despite having major defects. Please confirm this is correct.",
    Confirm: "Confirm",
    Yes: "Yes",
    No: "No",

    // trailer inspection prompt sheet
    TrailerInspectionPromptMessage: "Inspect the attached trailer {0}?",
    InspectTrailer: "Inspect trailer",
    SkipAndExit: "Skip and exit"
};

let getTranslations = () => {
    let r: string[] = [];
    for (const prop in InspectionsTranslationsDictionary) {
        r.push(InspectionsTranslationsDictionary[prop]);
    }
    return r;
};

export const InspectionsTranslations = getTranslations();
